import styled from '@emotion/styled'

export const Wrapper = styled.div``

export const Errors = styled.div``

export const TableList = styled.div``
